<script setup>
import {tgUrl} from "@/constants.js";
</script>

<template>
    <div class="w-full px-2.5 md:px-0 md:max-w-[640px] m-auto">
        <div class="mt-5 px-3 py-5 bg-sky-200 shadow-[4px_4px_12px_0_rgba(0,0,0,0.3)] flex flex-col items-center font-medium rounded-lg">
            <p class="text-black font-['Unbounded'] text-lg">
                {{$t('Participate in Giveaways!')}}
            </p>
            <div class="relative z-20 sm:z-0 mt-[22px] w-[146px]">
                <img alt="prizebox"
                     src="/assets/img/roblox/tg-draw-logo.webp" style="width: 101px; height: 106px">
            </div>
            <p class="flex items-center gap-3 font-sans text-base mt-[22px]">
                <span class="text-center" v-html="$t(`Join our telegram channel.<br>Every day we give away robuxes!`)"></span>
            </p>
            <a :href="tgUrl" target="_blank" class="flex mt-6 items-center gap-2.5 bg-cyan-500 shadow-[inset_1px_-3px_2px_rgba(0,0,0,0.3)] w-full justify-center py-4 rounded-full font-sans font-medium text-white transition-opacity hover:opacity-60">
                <span class="text-[18px]" v-html="$t('Join Channel')"></span>
                <img src="/assets/img/roblox/link-icon.svg" alt="link=icon" style="width: 30px; height: 30px;">
            </a>
        </div>
    </div>
</template>
<style lang="css">
@keyframes lifting-box-roblox-cover {
    0% {
        top: -40px
    }

    50% {
        top: -60px;
    }

    100% {
        top: -40px;
    }
}

.box-roblox-cover {
    animation-name: lifting-box-roblox-cover;
    animation-duration: 3s;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;

}
</style>
